import { ProductEnum } from "@doitintl/cmp-models";

export const options = [
  { label: "AWS", value: ProductEnum.AmazonWebServices },
  { label: "Google Cloud", value: ProductEnum.GoogleCloud },
  { label: "Azure", value: ProductEnum.MicrosoftAzure },
  { label: "Other e.g. Looker, Office 365", value: ProductEnum.Other },
];
